import React, { Component } from 'react';
import { Button, Col, ControlLabel, DropdownButton, FormControl, FormGroup, MenuItem, Row } from 'react-bootstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import EVScannerUser from './EVScannerUser';
import Merchant from './Merchant';
import VipMembers from './VipMembers';

class Create extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isPasswordResetting: false,
			isChangePassword: false,
			tempPassword: '',
			userType: null,
		};

		this.renderPassword = this.renderPassword.bind(this);
		this.showExtraForm = this.showExtraForm.bind(this);
	}
	componentWillMount() {
		let { formType, selectedData, stateSetter } = this.props;

		if (formType.toUpperCase() !== 'UPDATE') {
			selectedData.set('password', this.generatePassword(6));
			// stateSetter([{state: 'selectedData', value: formData}]);
			// console.log('componentWillMount password: ', selectedData.get('password'));
		}
	}
	generatePassword(length) {
		var text = '';
		var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

		for (var i = 0; i < length; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		return text;
	}

	renderPassword() {
		let { formType, selectedData } = this.props;
		let { isPasswordResetting, isChangePassword } = this.state;

		if (formType.toUpperCase() !== 'UPDATE') {
			return (
				<FormControl.Static style={{ fontStyle: 'italic' }}>
					{selectedData.get('password')}
				</FormControl.Static>
			);
		} else if (isChangePassword) {
			return (
				<div>
					<FormControl
						type="text"
						defaultValue={this.state.tempPassword}
						onChange={(e) => {
							const val = e.target.value.trim();
							if (val !== '') {
								selectedData.set('password', val);
							} else {
								selectedData.unset('password');
							}
						}}
					/>
					<a
						href="#"
						style={{ fontSize: '12px', color: '#999' }}
						onClick={(e) => {
							e.preventDefault();
							selectedData.unset('password');
							this.setState({ isChangePassword: false, tempPassword: '' });
						}}
					>
						Cancel
					</a>
				</div>
			);
		} else {
			return (
				<div>
				<DropdownButton title="CHANGE PASSWORD" id="password-options-dropdown">
					<MenuItem
						onSelect={() => {
							this.setState({ isPasswordResetting: true });
							Parse.User.requestPasswordReset(selectedData.getEmail())
								.then(() => {
									this.setState({ isPasswordResetting: false });
								})
								.catch((err) => {
									console.log('reset password error: ', err);
									this.setState({ isPasswordResetting: false });
								});
						}}
					>
						{isPasswordResetting ? (
							<span>
								<i className="fa fa-spinner fa-spin fa-1x" /> Sending...
							</span>
						) : (
							'SEND RESET PASSWORD'
						)}
					</MenuItem>
					<MenuItem
						onSelect={() => {
							const tempPassword = this.generatePassword(6);
							selectedData.set('password', tempPassword);
							this.setState({ isChangePassword: true, tempPassword });
						}}
					>
						SET TEMP PASSWORD
					</MenuItem>
				</DropdownButton>
				</div>
			);
		}
	}

	showExtraForm() {
		let { userType } = this.state;

		let { selectedData, loadOptions } = this.props;

		if (userType != null) {
			switch (userType.value.toUpperCase()) {
				case 'VIP HOST':
					return <VipMembers loadOptions={loadOptions} selectedData={selectedData} />;
					break;
				case 'MERCHANT':
					return <Merchant loadOptions={loadOptions} selectedData={selectedData} />;
					break;
				case 'PARTNER':
					return <EVScannerUser loadOptions={loadOptions} selectedData={selectedData} />;
				default:
					return '';
			}
		}
	}

	render() {
		let { selectedData, stateSetter } = this.props;

		return (
			<div>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>USERNAME</ControlLabel>
							<FormControl
								type="text"
								defaultValue={selectedData.get('username')}
								onInput={(e) => {
									selectedData.set('username', e.target.value);
								}}
							/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>PASSWORD</ControlLabel>
							{this.renderPassword()}
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>NAME</ControlLabel>
							<FormControl
								type="text"
								defaultValue={selectedData.get('name')}
								onInput={(e) => {
									selectedData.set('name', e.target.value.toUpperCase().trim());
								}}
							/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>EMAIL</ControlLabel>
							<FormControl
								type="text"
								defaultValue={selectedData.get('email')}
								onInput={(e) => {
									selectedData.set('email', e.target.value.trim());
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>MEMBER ID</ControlLabel>
							<FormControl
								type="text"
								defaultValue={selectedData.get('memberId')}
								onInput={(e) => {
									selectedData.set('memberId', e.target.value);
								}}
							/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>USER TYPE</ControlLabel>
							<Select
								value={this.state.userType}
								options={[
									{
										label: 'ADMIN',
										value: 'ADMIN',
									},
									{
										label: 'VIP HOST',
										value: 'VIP HOST',
									},
									{
										label: 'MERCHANT',
										value: 'MERCHANT',
									},
									{
										label: 'PARTNER',
										value: 'PARTNER',
									},
								]}
								onChange={(val) => {
									if (val) {
										console.log('defined: ', val);
										selectedData.set('userType', val.value);
									} else {
										console.log('else: ', val);
										selectedData.unset('userType');
									}
									this.setState({ userType: val });
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Cost Center / Outlet Name</ControlLabel>
							<FormControl
								type="text"
								defaultValue={selectedData.get('costCenter')}
								onInput={(e) => {
									if (e.target.value.trim() !== '') {
										selectedData.set('costCenter', e.target.value);
									} else {
										selectedData.unset('costCenter');
									}
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={12}>{this.showExtraForm()}</Col>
				</Row>
			</div>
		);
	}

	componentDidMount() {
		let { selectedData } = this.props;

		if (typeof selectedData.get('userType') !== 'undefined') {
			this.setState({
				userType: {
					label: selectedData.get('userType').toUpperCase(),
					value: selectedData.get('userType').toUpperCase(),
				},
			});
		}
	}
}

export default Create;



// WEBPACK FOOTER //
// ./components/UserSetup/FormContainer/Create.js